import { Component, OnInit, Input } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { AssetService } from 'src/app/services/asset.service';
import { StudentPortalService } from 'src/app/services/student-portal.service';

import { AssetTypes, NewAsset } from 'src/app/models/asset.model';
import { Observable, mergeMap, Subject, takeUntil } from 'rxjs';
import { StudentProfile } from 'src/app/pathways-ui/models/student-profile.model';
import { StudentModel } from 'src/app/pathways-ui/models/student.model';

const MAX_IMAGE_SIZE = 512 * 1024; // 512 KB

@Component({
  selector: 'app-student-profile-card',
  templateUrl: './student-profile-card.component.html',
  styleUrls: ['./student-profile-card.component.scss']
})


export class StudentProfileCardComponent implements OnInit {

  constructor(private _snackbar: MatSnackBar,
		private _translator: TranslateService, private _asset: AssetService, 
		private _studentPortalService: StudentPortalService) { }

  @Input() studentProfile: StudentProfile | undefined;

  uploadedAvatar: NewAsset;
  avatarUrl: any;
  hasAvatar: boolean = false;

  private destroyed$ = new Subject();

// TODO: Implement biography feature in future sprint
//   biography: string = "This is the default biography text."
//   isEditing: boolean = false;

  ngOnInit(): void 
  {
	if(!this.hasAvatar && this.studentProfile.avatarId != 0)
		this.getStudentAvatar();
  }

  getStudentAvatar()
  {
	this._studentPortalService.getStudentAvatar().pipe(
		takeUntil(this.destroyed$))
		.subscribe((blob) => {
			const url = URL.createObjectURL(blob);
			this.avatarUrl = url;
			this.hasAvatar = true;
		}, err => {
			console.log("Error fetching student avatar. ", err);
			this.hasAvatar = false;
		})
  }

  onUploadAvatarClick(event: any)
  {
    const file = event.target.files[0];
    if (!file) {
		return;
	}
	if (!(this.isTypeValid(file.type) && this.isSizeValid(file.size))) {
		return;
	}

	this._asset.blobToBase64(file).pipe(
		takeUntil(this.destroyed$),
		mergeMap((avatarData) => {
			const newAvatar: NewAsset = {
				type: AssetTypes.Avatar,
				originalFileName: file.name,
				contentType: file.type,
				fileData: avatarData.split(',')[1],
				fileExtension: file.name.split('.')[1]
			  }
			  this.uploadedAvatar = newAvatar;
			//   console.log("Avatar data:", this.uploadedAvatar)
			  return this._studentPortalService.uploadStudentAvatar(this.uploadedAvatar);
		})).subscribe(() => {
			console.log("Avatar upload complete.");
			this.getStudentAvatar();
		})
  }

// TODO: Implement biography feature in future sprint
//   toggleEdit()
//   {
// 	this.isEditing = !this.isEditing;
//   }

//   saveBiography(newBiography: string)
//   {
// 	this.biography = newBiography;
// 	this.isEditing = false;
//   }

  private isSizeValid(size: number) {
		if (size > MAX_IMAGE_SIZE) {
			this._snackbar.open(
				this._translator.instant(
					'The file you chose is too large. Please upload an image that is less than 512 kb'
				),
				this._translator.instant('Dismiss')
			);
			return false;
		}
		return true;
	}

	private isTypeValid(type: string) {
		const isAcceptedFileType = this.checkIfCorrectFileType(type);
		let isFileValid = true;
		if (!isAcceptedFileType) {
			this._snackbar.open(
				this._translator.instant(
					'The file you chose is the wrong type. Please upload an image with a .png, .jpg or .jpeg extension'
				),
				this._translator.instant('Dismiss')
			);
			isFileValid = false;
		}
		return isFileValid;
	}

	checkIfCorrectFileType(type: string) {
		const approvedFileTypes = ['image/png', 'image/jpeg', 'image/jpg'];

		if (approvedFileTypes.includes(type)) {
			return true;
		} else {
			return false;
		}
	}

	ngOnDestroy()
	{
		this.destroyed$.next(true);
		this.destroyed$.complete();
	}

}
